'use memo';

import { Outlet, createFileRoute, useMatchRoute } from '@tanstack/react-router';
import { VStack } from '@/components/Layout';
import { AuthenticationHeader } from './_layout/-components/AuthenticationHeader';
export const Route = createFileRoute('/_staff/settings/authentication/_layout')({
  component: RouteComponent
});
function RouteComponent() {
  const matchRoute = useMatchRoute();
  // 作成・編集ステッパーは親の ProductHeader（認証タイトル＋タブ）を出さない
  // （permission-and-roles / person/add と同様）
  const hideAuthenticationHeader = Boolean(matchRoute({
    to: '/settings/authentication/access-rules/new'
  })) || Boolean(matchRoute({
    to: '/settings/authentication/access-rules/$id'
  })) || Boolean(matchRoute({
    to: '/settings/authentication/policies/new'
  })) || Boolean(matchRoute({
    to: '/settings/authentication/policies/$id'
  }));
  return <VStack className="h-full gap-0">
      {!hideAuthenticationHeader ? <AuthenticationHeader /> : null}
      {/* ページ背景は _staff の bg-neutral-bottom-fill を継承（メンバー一覧と同系） */}
      <div className="relative min-h-0 flex-1 overflow-auto">
        <Outlet />
      </div>
    </VStack>;
}